import script from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=aa20d9b6&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa20d9b6"]])

export default __exports__